import { AuthActionTypes, SET_USER_INFO, SET_ROLE, SET_AUTHENTICATED, RESET_ROLE } from "../actions/authAction";
import { UserInfo } from "../../utils/types";
import { authService } from "../../utils/authServices";

interface AuthState {
  role: string;
  userInfo: UserInfo | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  role: authService.getPrimaryRole(), // Directly get the human-readable role
  userInfo: authService.getUserInfo(),
  isAuthenticated: !authService.isTokenExpired(),
};

const authReducer = (state = initialState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
    case SET_ROLE:
      // Map human-readable role to internal value and update in authService
      const roleValue = action.payload === 'admin' ? '1' : action.payload === 'unitadmin' ? '2' : '';
      const currentData = authService.getToken() || { exp: 0, e: '', n: '', r: '', t: '' };

      authService.setToken({ ...currentData, r: roleValue });

      return {
        ...state,
        role: action.payload, // Store human-readable role in the state
      };

    case SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
      };

      case SET_USER_INFO:
        const userInfoWithRole = {
          ...action.payload,
          role: state.role, // Use the current state's role if not provided
        };
        authService.setUserInfo(userInfoWithRole);
        return {
          ...state,
          userInfo: action.payload,
        };
    case RESET_ROLE:
      // Reset role to guest (empty string) in authService
      const resetData = authService.getToken() || { exp: 0, e: '', n: '', r: '', t: '' };
      authService.setToken({ ...resetData, r: '' });

      return {
        ...state,
        role: '', // Reset human-readable role to empty
      };

    default:
      return state;
  }
};

export default authReducer;
